import Avatar from '@carrier-io/air-react/Avatar';
import Box from '@carrier-io/air-react/Box';
import AppBarTopHeader from '@carrier-io/air-react/patterns/AppBarTopHeader';
import Typography from '@carrier-io/air-react/Typography';
import Menu from '@carrier-io/air-react/Menu';
import AvatarIcon from './icons/avatar-icon';
import IconButton from '@carrier-io/air-react/IconButton';
import { useState } from 'react';
import MenuItem from '@carrier-io/air-react/MenuItem';
import Button from '@carrier-io/air-react/Button';
import { useAuth } from 'context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { HomeMenuIcon } from './icons/HomeMenuIcon';

function AppTopBar() {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleUserProfileMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div style={{ zIndex: 10 }}>
      <AppBarTopHeader
        appBarProps={{
          color: 'appBarBackground',
        }}
        centralComponent={
          <Box
            data-testid="central-child-component"
            sx={{
              maxWidth: '100%',
              height: '100%',
              overflow: 'hidden',
              padding: 1,
              textAlign: 'left',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            <Typography
              variant="h6"
              color="secondary"
              sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
              title="Customizable central child"
            >
              Header
            </Typography>
          </Box>
        }
        leftJustifiedComponent={
          <Box
            data-testid="left-child-component"
            sx={{
              alignItems: 'center',
              display: 'flex',
              justifyContent: 'center',
              width: 64,
            }}
          >
            <HomeMenuIcon />
          </Box>
        }
        rightJustifiedComponent={
          <Box data-testid="right-child-component" sx={{ paddingRight: 2 }}>
            <IconButton data-testid="user-profile" onClick={handleUserProfileMenu}>
              <Avatar title="User Profile" style={{ width: '40px' }}>
                <AvatarIcon />
              </Avatar>
            </IconButton>
          </Box>
        }
        toolbarProps={{
          disableGutters: true,
          variant: 'dense',
          style: {
            borderBottomStyle: 'solid',
            borderBottomWidth: '2px',
            borderBottomColor: '#DCDEE0',
            minHeight: '48px',
            width: '100%',
            position: 'fixed',
          },
        }}
      />
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        //anchorReference="anchorPosition"
        //anchorPosition={{ top: 70, left: 0 }}
        // anchorOrigin={{
        //   vertical: "bottom",
        //   horizontal: "right",
        // }}
        // transformOrigin={{
        //   vertical: "top",
        //   horizontal: "right",
        // }}
        style={{ padding: 0 }}
        MenuListProps={{ style: { padding: 0, maxWidth: '104px' } }}
      >
        <MenuItem
          style={{
            padding: '14px 16px 14px 16px',
          }}
        >
          <Button
            data-testid="logout"
            variant="outlined"
            style={{ fontSize: 14, lineHeight: '20px', height: 40 }}
            onClick={() => {
              logout();
              navigate('/');
            }}
          >
            Logout
          </Button>
        </MenuItem>
      </Menu>
    </div>
  );
}

export default AppTopBar;
